import * as React from "react";
import { handleLineBreaks } from "../helpers/prismicHelpers";
import { Link } from "gatsby";
import { RichText } from "prismic-reactjs";
import "./expanders.scss";
export var Expanders = function Expanders(_ref) {
  var data = _ref.data;
  return /*#__PURE__*/React.createElement("div", {
    className: "expanders"
  }, /*#__PURE__*/React.createElement("div", {
    className: "fixed-width"
  }, /*#__PURE__*/React.createElement("div", {
    className: "expander-header"
  }, /*#__PURE__*/React.createElement("h4", null, data.primary.sub_header), /*#__PURE__*/React.createElement("h2", null, data.primary.header)), data.fields.map(function (expander) {
    return /*#__PURE__*/React.createElement(Expander, {
      header: expander.expander_header,
      content: expander.expander_body
    });
  }), /*#__PURE__*/React.createElement("div", {
    className: "btn-block"
  }, /*#__PURE__*/React.createElement(Link, {
    className: "btn",
    to: data.primary.path
  }, data.primary.action))));
};

var Expander = function Expander(_ref2) {
  var header = _ref2.header,
      content = _ref2.content;

  var _React$useState = React.useState(false),
      open = _React$useState[0],
      setOpen = _React$useState[1];

  return /*#__PURE__*/React.createElement("div", {
    className: "expander",
    "data-expanded": open
  }, /*#__PURE__*/React.createElement("div", {
    className: "expander-header-clicker",
    onClick: function onClick() {
      return setOpen(!open);
    }
  }, /*#__PURE__*/React.createElement("h2", null, handleLineBreaks(header)), /*#__PURE__*/React.createElement("img", {
    className: "expander-button",
    src: require('../assets/images/expander.svg'),
    alt: "Expander arrow"
  })), /*#__PURE__*/React.createElement("div", {
    className: "expander-content",
    style: {
      maxHeight: open ? '600px' : '0'
    }
  }, RichText.render(content)));
};